import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "page-content" };
import _ from "lodash";
import ProjectMainInfo from "@/components/uikit/platformComponents/project/ProjectMainInfo.vue";
import ProjectSubInfo from "@/components/uikit/platformComponents/project/ProjectSubInfo.vue";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectPage',
    setup(__props) {
        const route = useRoute();
        const projectId = route.params.id;
        const store = useStore();
        const loading = ref(true);
        onMounted(async () => {
            await store.dispatch("capitals/getAuCapitals", projectId);
            await store.dispatch("getSectionCapital");
            await store.dispatch("getCountry");
            if (_.isEmpty(store.getters["owner/getAuOwners"])) {
                await store.dispatch("owner/getAuOwners");
            }
            loading.value = false;
        });
        const project = computed(() => store.getters["capitals/auCapital"]);
        const breadcrumbItems = computed(() => [
            { label: "Marketplace", route: "/projects" },
            { label: project.value ? project.value.nameEng : "Project" }
        ]);
        return (_ctx, _cache) => {
            const _component_UProgressBar = _resolveComponent("UProgressBar");
            const _component_UBreadcrumbs = _resolveComponent("UBreadcrumbs");
            const _component_UList = _resolveComponent("UList");
            return (loading.value)
                ? (_openBlock(), _createBlock(_component_UProgressBar, {
                    key: 0,
                    green: "",
                    "is-loader": ""
                }))
                : (_openBlock(), _createBlock(_component_UList, { key: 1 }, {
                    default: _withCtx(() => [
                        _createVNode(_component_UBreadcrumbs, { items: breadcrumbItems.value }, null, 8, ["items"]),
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(ProjectMainInfo),
                            _createVNode(ProjectSubInfo)
                        ])
                    ]),
                    _: 1
                }));
        };
    }
});
